import React from 'react';
import { Card, Form, Select, DatePicker, Input, Button, Space } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import {
    PdfExportFilters,
    PdfExportStatusValue,
    PDF_EXPORT_STATUS_OPTIONS,
    PDF_EXPORT_TRIGGER_OPTIONS,
} from './types';

interface Props {
    value: PdfExportFilters;
    onChange: (next: PdfExportFilters) => void;
    onClear: () => void;
}

const { RangePicker } = DatePicker;

const FilterBar: React.FC<Props> = ({ value, onChange, onClear }) => {
    const range: [Dayjs | null, Dayjs | null] = [
        value.from ? dayjs(value.from) : null,
        value.to ? dayjs(value.to) : null,
    ];

    return (
        <Card size="small" style={{ marginBottom: 16 }}>
            <Form layout="vertical">
                <Space wrap size="middle" style={{ width: '100%' }} align="end">
                    <Form.Item label="Status" style={{ minWidth: 240, marginBottom: 0 }}>
                        <Select
                            mode="multiple"
                            allowClear
                            placeholder="Any status"
                            value={value.statuses}
                            onChange={(statuses: PdfExportStatusValue[]) =>
                                onChange({ ...value, statuses })
                            }
                            options={PDF_EXPORT_STATUS_OPTIONS}
                            style={{ minWidth: 240 }}
                        />
                    </Form.Item>

                    <Form.Item label="Queued at" style={{ marginBottom: 0 }}>
                        <RangePicker
                            showTime
                            value={range as any}
                            onChange={(dates) => {
                                onChange({
                                    ...value,
                                    from: dates?.[0]?.toISOString() ?? null,
                                    to: dates?.[1]?.toISOString() ?? null,
                                });
                            }}
                        />
                    </Form.Item>

                    <Form.Item label="Trigger" style={{ minWidth: 160, marginBottom: 0 }}>
                        <Select
                            allowClear
                            placeholder="Any"
                            value={value.trigger ?? undefined}
                            onChange={(trigger) => onChange({ ...value, trigger: trigger ?? null })}
                            options={PDF_EXPORT_TRIGGER_OPTIONS}
                            style={{ minWidth: 160 }}
                        />
                    </Form.Item>

                    <Form.Item label="Account ID" style={{ minWidth: 240, marginBottom: 0 }}>
                        <Input.Search
                            placeholder="Exact match"
                            allowClear
                            value={value.accountId ?? ''}
                            onChange={(e) =>
                                onChange({ ...value, accountId: e.target.value || null })
                            }
                            onSearch={(v) => onChange({ ...value, accountId: v || null })}
                            style={{ minWidth: 240 }}
                        />
                    </Form.Item>

                    <Form.Item label="Document ID" style={{ minWidth: 240, marginBottom: 0 }}>
                        <Input.Search
                            placeholder="Exact match"
                            allowClear
                            value={value.documentId ?? ''}
                            onChange={(e) =>
                                onChange({ ...value, documentId: e.target.value || null })
                            }
                            onSearch={(v) => onChange({ ...value, documentId: v || null })}
                            style={{ minWidth: 240 }}
                        />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button onClick={onClear}>Clear filters</Button>
                    </Form.Item>
                </Space>
            </Form>
        </Card>
    );
};

export default FilterBar;
